/**
 * Created by lobin on 2017/12/4.
 */
export  default {
	yuantong:require("../expressicon/圆通.jpg"),
	shengtong:require("../expressicon/申通.jpg"),
	zhongtong:require("../expressicon/中通.jpg"),
	baishi:require("../expressicon/百世.jpg"),
	shunfeng:require("../expressicon/顺丰.jpg"),
	ems:require("../expressicon/EMS.jpg"),
	youzheng:require("../expressicon/邮政.jpg"),
	kuaijie:require("../expressicon/快捷.jpg"),
	jingdong:require("../expressicon/京东.jpg"),
	pinjun:require("../expressicon/唯品会.jpg"),
	guotong:require("../expressicon/国通.jpg"),
	tiantian:require("../expressicon/天天.jpg"),
	anneng:require("../expressicon/安能.jpg"),
	tmall:require("../expressicon/天猫.jpg"),
	deibang:require("../expressicon/德邦.jpg"),
	yousu:require("../expressicon/优速.jpg"),
	wanxiang:require("../expressicon/万象.jpg"),
	dongjun:require("../expressicon/东骏.jpg"),
	suning:require("../expressicon/苏宁.jpg"),
	yunda:require("../expressicon/韵达.jpg"),
	yamaxun:require("../expressicon/快递运输.png"),
	zhaojisong:require("../expressicon/宅急送.jpeg"),
	lijisong:require("../expressicon/快递运输.png"),
	vip:require("../expressicon/唯品会.jpg"),
	quanf:require("../expressicon/快递运输.png"),
	tongcheng:require("../expressicon/快递运输.png"),
	suerkuaidi:require("../expressicon/快递运输.png"),
	wuliu:require("../expressicon/快递运输.png"),
	jtexpress: require("../expressicon/jtexpress.png")
}
export const defaulticon =  require("../expressicon/快递运输.png")